import React from "react";
import { useTranslation } from "react-i18next";

const DonateAmount = ({
  amount,
  setAmount,
  customAmount,
  setCustomAmount,
  nextStep
}) => {

  const { t } = useTranslation();

  /* ----------------------------------------
  Convert Marathi / Hindi digits → English
  ---------------------------------------- */

  const normalizeDigits = (str) => {

    if (!str) return str;

    const map = {
      "०":"0","१":"1","२":"2","३":"3","४":"4",
      "५":"5","६":"6","७":"7","८":"8","९":"9"
    };

    return str.replace(/[०१२३४५६७८९]/g, d => map[d]);
  };

  /* ----------------------------------------
  PRESET AMOUNT BUTTON
  ---------------------------------------- */

  const handleButtonAmount = (value) => {
    setAmount(value);
    setCustomAmount("");
  };

  /* ----------------------------------------
  CUSTOM AMOUNT INPUT
  ---------------------------------------- */

  const handleCustomAmount = (e) => {

    let value = e.target.value;

    if (value === "") {
      setCustomAmount("");
      setAmount(null);
      return;
    }

    /* convert Marathi digits */

    value = normalizeDigits(value);

    /* allow only numbers */

    if (!/^[0-9]*$/.test(value)) return;

    const number = Number(value);

    if (!isNaN(number) && number >= 1 && number <= 10000000) {

      setCustomAmount(value);
      setAmount(null);

    }

  };

  /* ----------------------------------------
  VALIDATION
  ---------------------------------------- */

  const validAmount =
    amount !== null ||
    (customAmount &&
      Number(normalizeDigits(customAmount)) >= 1 &&
      Number(normalizeDigits(customAmount)) <= 10000000);

  /* ----------------------------------------
  UI
  ---------------------------------------- */

  return (

    <div className="d_donate_card">

      <h1>{t("donate.title")}</h1>

      <p className="d_donate_subtitle">
        {t("donate.subtitle")}
      </p>

      {/* 80G MESSAGE */}

      <div
        className="tax-benefit-box"
        style={{
          fontSize: "14px",
          color: "#555",
          marginBottom: "20px",
          padding: "10px",
          backgroundColor: "#f9f9f9",
          borderLeft: "4px solid #28a745"
        }}
      >

        {t("donate.tax_msg_1")}
        <b> {t("donate.tax_msg_80g")} </b>
        {t("donate.tax_msg_2")}

      </div>

      {/* STEP TITLE */}

      <h3 className="d_donate_label">
        {t("donate.step_amount")}
      </h3>

      {/* PRESET BUTTONS */}

      <div className="d_amount_buttons">

        {[500, 1000, 2000, 5000].map((value) => (

          <button
            key={value}
            className={amount === value ? "selected" : ""}
            onClick={() => handleButtonAmount(value)}
          >

            {t("donate.currency_symbol")}{value}

          </button>

        ))}

      </div>

      {/* CUSTOM AMOUNT */}

      <input
        type="text"
        inputMode="numeric"
        placeholder={t("donate.placeholder_other")}
        value={customAmount}
        onChange={handleCustomAmount}
      />

      {/* OPTIONAL MESSAGE */}

      <label>{t("donate.label_message")}</label>

      <textarea
        placeholder={t("donate.placeholder_message")}
      ></textarea>

      {/* NEXT BUTTON */}

      <button
        className="d_donate_btn"
        disabled={!validAmount}
        onClick={nextStep}
      >

        {t("common.next_step")}

      </button>

    </div>

  );

};

export default DonateAmount;